module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1015-59095eb04963d0918270dadc0dd80d65.png";